export const textBlue = "#29235c"
export const bgblue1 = "#0f70b7"
export const bgblue2 = "#1d2a49"
export const neonblue = "#53FFFF"
export const textBlue2 = "#0070c0"
